import { useFormikContext } from 'formik';
import React from 'react';
import { ContasPagarRetencao } from '../../components';

const ContasPagarAbaRetencao = () => {
  const formikContext = useFormikContext();

  const { values, handleChange, handleBlur, errors, touched } = formikContext;

  return (
    <ContasPagarRetencao
      values={values}
      handleChange={handleChange}
      handleBlur={handleBlur}
      errors={errors}
      touched={touched}
    />
  );
};

export default ContasPagarAbaRetencao;
